import { SET_TOASTS, REMOVE_TOAST, ADD_TOAST } from './actions';

const initialToastState = {
    toasts: [],
};

export const toasts = (state = initialToastState, action) => {
    switch (action.type) {
        case SET_TOASTS:
            return {
                ...state,
                toasts: action.toasts,
            };
        case REMOVE_TOAST:
            const updatedToasts = state.toasts.filter((toast) => toast.id !== action.toastId);
            return {
                ...state,
                toasts: updatedToasts,
            };
        case ADD_TOAST:
            return {
                ...state,
                toasts: [...state.toasts, action.toast],
            };
        default:
            return state;
    }
};